import { ParsedPlace } from './parsePlaceResult';

// Compares the suggestion label against the address components Google
// returned for it, not against the rendered address strings. The route
// component carries both spellings ("South Orange Avenue" / "S Orange Ave"),
// so either form of the label counts as a match and abbreviation never
// triggers the warning. A record with no street_number builds a street line
// without a number, so a numbered label mismatches it on its own. State and
// ZIP are never compared: the label abbreviates the state and carries no ZIP.
const normalize = (text: string): string =>
  text.trim().replace(/\s+/g, ' ').toLowerCase();

const streetLine = (streetNumber: string, route: string): string =>
  [streetNumber, route].filter(Boolean).join(' ');

export const isAddressMismatch = (parsed: ParsedPlace): boolean => {
  if (!parsed.selected) return false;
  const { mainText, secondaryText } = parsed.selected;
  const { streetNumber, routeLong, routeShort } = parsed.found;

  const acceptedStreetLines = [routeLong, routeShort]
    .filter(Boolean)
    .map(route => normalize(streetLine(streetNumber, route)));
  if (!acceptedStreetLines.includes(normalize(mainText))) return true;

  return normalize(secondaryText.split(',')[0]) !== normalize(parsed.city);
};
